<template>
  <div class="view economy">


    <div class="filterbtns">
      <filterbtn v-for="(tab,tab_i) in tabs" :key="'tab'+tab_i" :active="tab_key_active==tab.key" @click.native="tab_key_active = tab.key">{{tab.label}}</filterbtn>      
    </div>
    
    <br>


    <box :label="'Overblik: '+yearTitle" v-if="tab_key_active=='main'">
      <template slot="meta-r">
        <template v-if="true">
          <div class="textlink" @click="toggle_calculate_hypothetic_posts()">
            <template v-if="calculate_hypothetic_posts">● Hypotetiske</template>
            <template v-else>○ Hypotetiske</template>            
          </div>
          &nbsp;&nbsp;&nbsp;
          <div class="textlink" v-if="place_posts_by=='invoice_date'" @click="place_posts_by='payment_due_date'">Regnskab</div>
          <div class="textlink" v-if="place_posts_by=='payment_due_date'" @click="place_posts_by='invoice_date'">Likviditet</div>
           &nbsp;&nbsp;&nbsp;           
        </template>
        <div class="textlink" @click="gotoPrevMonth()">
          <svgicon icon="ionicons/chevron-left"></svgicon>
        </div>
        <div class="textlink" @click="gotoNextMonth()">
          <svgicon icon="ionicons/chevron-right"></svgicon>
        </div>
      </template>

      <div style="overflow-x:hidden;">
    
      <table class="table-eco">
        <thead>
          <tr>
            <th></th>
            <th v-for="(month,month_i) in activeYearPosts" class="monthCLickTitle" :class="{active: ( activeMonthNumber==(month.month) ) }" @click="gotoMonthYear(month.month,month.year)">
              {{monthName(month.month)}}<br> {{month.year}}
            </th>
          </tr>
        </thead>
        <tbody>

          <tr class="">
            <td>Indtægter</td>
            <td v-for="i in 12" :class="negaPosi_cls(activeYearPosts[i-1].totals.income_total)">{{outputMoney(activeYearPosts[i-1].totals.income_total)}}</td>
          </tr>
          <tr class="">
            <td>Udgifter</td>
            <td v-for="i in 12" :class="negaPosi_cls(activeYearPosts[i-1].totals.expense_total)">{{outputMoney(activeYearPosts[i-1].totals.expense_total)}}</td>
          </tr>
          <tr class="spacer"><td colspan="13"></td></tr>
          <tr>
            <td><b>Total</b></td>
            <td v-for="i in 12" :class="negaPosi_cls(activeYearPosts[i-1].totals.total)"><b>{{outputMoney(activeYearPosts[i-1].totals.total)}}</b></td>
          </tr>
          <tr class="spacer"><td colspan="13"></td></tr>
          <tr>
            <td>Bankbeholdning</td>
            <td v-for="i in 12" :class="negaPosi_cls(10)">{{outputMoney(10)}}</td>
          </tr>
          
        </tbody>
      </table>

      </div>

    </box>





  <box :label="'Økonomiposter: '+now.format('MMM YYYY')" v-if="tab_key_active=='main'">

    <template slot="meta-r">
      <div class="textlink" @click="gotoPrevMonth()">
        <svgicon icon="ionicons/chevron-left"></svgicon>
      </div>
      <div class="textlink" @click="gotoNextMonth()">
        <svgicon icon="ionicons/chevron-right"></svgicon>
      </div>
    </template>

    <economy-posts :posts="activeMonthPosts.posts" :totals="activeMonthPosts.totals" />    

    <br>

    <btn @click.native="createNewEconomypost()">Opret ny økonomipost</btn>    

  </box>



  <box :label="'Nøgletal ' + yearTitle" v-if="tab_key_active=='keyfigs'" :open="keyFiguresExpanded" @toggledOpen="flipBoolean('keyFiguresExpanded')">

    <table class="table-eco">
      <thead>
        <tr>
          <th></th>
          <th v-for="i in 4">Q{{i}}</th>          
          <th>{{yearTitle}}</th>                    
        </tr>
      </thead>
      <tbody>
        
        
        <tr>
          <td>Indtægter</td>
          <td v-for="i in 4" class="posi">{{ outputMoney( activeYearTotals['q'+i].income,0) }}</td>          
          <td class="posi">{{ outputMoney( activeYearTotals.year.income,0) }}</td>
        </tr>

        <tr>
          <td>Udgifter</td>
          <td v-for="i in 4" class="nega">{{ outputMoney( activeYearTotals['q'+i].expense,0) }}</td>          
          <td class="nega">{{ outputMoney( activeYearTotals.year.expense,0) }}</td>
        </tr>

        <tr class="spacer"><td colspan="6"></td></tr>

        <tr>
          <td><b>Total</b></td>
          <td v-for="i in 4" :class="negaPosi_cls(activeYearTotals['q'+i].total)"><b>{{ outputMoney( activeYearTotals['q'+i].total,0) }}</b></td>          
          <td :class="negaPosi_cls(activeYearTotals.year.total)"><b>{{ outputMoney( activeYearTotals.year.total,0) }}</b></td>
        </tr>

      </tbody>
    </table>
  </box>




  <box label="Mangler fakturering" v-if="tab_key_active=='missing'" :open="missingInvoiceExpanded" @toggledOpen="flipBoolean('missingInvoiceExpanded')">
    <p>Her vises alle posteringer som mangler fakturering, så de kan behandles.</p>        
    <br>
    <p>Total: {{outputMoney(needing_invoices.totals.total)}} kr.</p>
    <br>
    <template v-for="(p) in needing_invoices.posts">
      <div class="btn" @click="openEconomypost(p)">
        {{ p.title || 'Unnamed' }} &mdash; {{outputMoney(p.amount_dkk_ex_vat)}} kr.
      </div> &nbsp; 
    </template>
  </box>



  <box label="Mangler betaling" v-if="tab_key_active=='missing'" :open="missingPaymentExpanded" @toggledOpen="flipBoolean('missingPaymentExpanded')">
    <p>Her vises alle posteringer som mangler bettaling, så de kan behandles.</p>    
    <br>
    <p>Total: {{outputMoney(needing_payment.totals.total)}} kr.</p>
    <br>
    <template v-for="(p) in needing_payment.posts">
      <div class="btn" @click="openEconomypost(p)">
        {{ p.title || 'Unnamed' }} &mdash; {{outputMoney(p.amount_dkk_ex_vat)}} kr.
      </div> &nbsp; 
    </template>
  </box>



  <box label="Momsafregning" v-if="tab_key_active=='vat'" :open="vatViewExpanded" @toggledOpen="flipBoolean('vatViewExpanded')">
    <p>Her vises moms +/-/total på måneds, kvartals og halvårsbasis</p>    
  </box>



  <box label="Indtjening" v-if="false">
    <template slot="meta-r">
      <div class="textlink">
        &mdash;
      </div>
    </template>

    {{chart1}}

    <vue-chart
        :columns="[ {type:'string',label:'year'}, {type:'string',label:'year2'}, {type:'string',label:'year3'} ]"
        :rows="[ [200,33,442],[100,133,242] ]"
        :options="{}"
    ></vue-chart>

  </box>


  <box v-if="false" :label="'Samlet kundeindtjening'" :open="clientEarningsExpanded" @toggledOpen="flipBoolean('clientEarningsExpanded')">>
    <template slot="meta-r">
      fra <input type="date" v-model="client_earnings_date_from"> til <input type="date" v-model="client_earnings_date_to">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </template>
    <div class="grid">
      <div class="col m50">

        <div class="chart-minitable">
          <peity :type="'pie'" :options="{ 'fill': pieChartColors, width: 250, height:250,  'innerRadius': 0, 'radius': 140 }" :data="clientsEconomyListPieData"></peity>
        </div>

      </div>
      <div class="col m50">

        <div class="chart-minitable">
          <div class="title">Kunder</div>
          <div class="entry" v-for="(entry,i) in clientsEconomyList">
            <span class="colorcircle" :style="{'background-color':pieChartColors[i]}"></span>
            <span class="name">
              {{clients[entry.client_key].name}}
            </span>
            <span class="pct">
              {{entry.pct}} %
            </span>
            <span class="hours">
              {{ outputMoney( entry.earning , 'a' ) }} kr.
            </span>
          </div>
        </div>

      </div>
    </div>
  </box>


  <box :label="'Chart'" v-if="false && globals.show_beta_content">
    <vue-chartist :data="chartist_data" :options="chartist_options" type="Line"></vue-chartist>
  </box>

  <box :label="'År: '+ activeYear" v-if="false && globals.show_beta_content">

    <p>Sparkline chart over månederne, med enten invoiced, eller også paid, eller begge.</p>

    <table class="table-a">
      <thead>
        <tr>
          <th v-for="i in 12" :class="{'this-month':i==activeMonth}">
            <span v-if="i==activeMonth"> --&gt; </span>
            {{i}}
            <span v-if="i==activeMonth"> &lt;-- </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="i in 12" :class="{'this-month':i==activeMonth}">
            {{i}}
          </td>
        </tr>
      </tbody>
    </table>

    <p>
      {{yearStats}}
    </p>

    <trend
      :data="yearStats"
      :gradient="['#000', '#000', '#000']"
      auto-draw
      smooth>
    </trend>

	</box>
  

  </div>
</template>

<script>
import fdb from '.././firebase_config.js';
import _ from 'lodash'
import mixins from '../mixins.js';
import moment from 'moment'
import auth from './../auth.js'
import helpers from '../helpers.js'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Avatar from '.././components/Avatar'
import Filterbtn from '.././components/Filterbtn'
import Minipctbar from '.././components/Minipctbar'
import Minidonut from '.././components/Minidonut'
import EconomyPosts from '.././components/EconomyPosts'
import VueChartist from 'v-chartist'
import './../components/generated_svg_icons/ionicons/chevron-left'
import './../components/generated_svg_icons/ionicons/chevron-right'
import './../components/generated_svg_icons/ionicons/gear-a'
import './../components/generated_svg_icons/ionicons/checkmark'
import Peity from 'vue-peity'
export default {
  components: { Box, Btn, Avatar, Minipctbar, Minidonut, Inputfield, 'vue-chartist': VueChartist, Peity, Filterbtn, EconomyPosts },
  name: 'economy',
  mixins: [ mixins.db, mixins.generic ],
  data: function () {
    return {
      globals: this.$parent.globals,

      tabs: [
        { key:'main', label:'Overblik' },
        { key:'keyfigs', label:'Nøgletal' },
        { key:'missing', label:'Til afklaring' },
        { key:'vat', label:'Moms' },
      ],
      tab_key_active: 'main',

      month_offset: 0,
      accounting_month_offset: 6,

      place_posts_by: 'invoice_date', // 'payment_due_date',

      keyFiguresExpanded: true,
      clientEarningsExpanded: false,

      missingInvoiceExpanded: true,
      missingPaymentExpanded: true,
      vatViewExpanded: true,
      
      activeEconomypostKey: undefined,
      activeEconomypost: undefined,
      user: auth.getUser(),
      monthNames: [ 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december' ],

      chartist_data: {
          labels: [ 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december' ],
          series: [
              [1050,10,2,3,3,2,1,4,5,5,2,1],
          ]
      },
      chartist_options: {
          fullWidth: true,
          chartPadding: {
              right: 140
          }
      },

      pieChartColors: ['#9FFFCB','#004E64','#00A5CF','#7AE582','#CDCDCD','#214E34','#E4959E','#CB9CF2','#9E7B9B','#F35B04','#7678ED'],

      client_earnings_date_from: undefined,
      client_earnings_date_to: undefined,

    }
  },
  computed:{

    calculate_hypothetic_posts(){ return this.$store.state.economyposts.calculate_hypothetic_posts },

    now(){
      return moment().add(this.month_offset,'month')
    },

    activeMonthNumber(){
      return parseInt(this.now.format('M'))
    },

    activeMonthPosts(){
      return this.getFilteredAndTotals({
        date_from_timestamp: moment(this.now,'YYYY-MM-DD').startOf('month').unix(),
        date_to_timestamp: moment(this.now,'YYYY-MM-DD').endOf('month').unix(),
      })
    },

    activeYearPosts(){
      var output = []
      
      //var monthnumbers = this.accounting_months
      //for( var i = 0; i < monthnumbers.length; i++ ) {

      for( var i = 1; i <= 12; i++ ){

        //var monthNumber = monthnumbers[i]
        var monthNumber = i

        var month_moment = moment(this.now)
                            .month( monthNumber - 1 )
                            .add( this.accounting_month_offset, 'months' )                            

        /////if( this.activeMonthNumber + this.accounting_month_offset > 12) month_moment.add(-1,'year')

        if( this.activeMonthNumber-1 < this.accounting_month_offset ) {
          //console.log('addone: '+monthNumber)
          //console.log('activeMonthNumber: '+this.activeMonthNumber)
          month_moment.add(-1,'year')
        }

        var data = this.getFilteredAndTotals({
          place_posts_by:      this.place_posts_by,
          date_from_timestamp: moment(month_moment).startOf('month').unix(),
          date_to_timestamp:   moment(month_moment).endOf('month').unix(),
        })
        data.title = month_moment.format('MMM YYYY')
        data.month = month_moment.format('M')
        data.year  = month_moment.format('Y')
        output.push(data)
      }
      return output
    },


    activeYearTotals(){

      var output = {
        q1: { income:0, expense:0, total:0 },
        q2: { income:0, expense:0, total:0 },
        q3: { income:0, expense:0, total:0 },
        q4: { income:0, expense:0, total:0 },
        year: { income:0, expense:0, total:0 },
      }
      
      for( var i = 0; i < this.activeYearPosts.length; i++ ) {
        var m = this.activeYearPosts[i]
        var qno = Math.ceil(( (i+1) / 12 ) * 4)
        output['q'+qno].income += m.totals.income_total; output['q'+qno].expense += m.totals.expense_total; output['q'+qno].total += m.totals.total;
        output.year.income += m.totals.income_total; output.year.expense += m.totals.expense_total; output.year.total += m.totals.total;
      }

      return output
    },



    yearTitle(){

      if( this.accounting_month_offset > 0) {
        if( this.now.month() + 1 > this.accounting_month_offset ) {
          return this.now.format('YYYY') + '-' + moment(this.now).add(1,'year').format('YYYY')
        } else {
          return moment(this.now).add(-1,'year').format('YYYY') + '-' + this.now.format('YYYY')
        }        
      }

      return this.now.format('YYYY')

    },

    /*
    accounting_months(){
      var output = []
      var firstMonthIndex = this.accounting_month_offset - 1
      var arr = [ 1,2,3,4,5,6,7,8,9,10,11,12 ]
      var output = arr.slice( firstMonthIndex, 12 ).concat( arr.slice(0,firstMonthIndex) )
      return output
    },
    */












    economyposts(){ return this.$store.state.firebase.economyposts },
    clients(){ return this.$store.state.firebase.clients },
    projects(){ return this.$store.state.firebase.projects },

    

    

    

    //q1_stats(){ return this.getMonthStats_multiple( [1,2,3], this.activeYear ) },
    //q2_stats(){ return this.getMonthStats_multiple( [4,5,6], this.activeYear ) },
    //q3_stats(){ return this.getMonthStats_multiple( [7,8,9], this.activeYear ) },
    //q4_stats(){ return this.getMonthStats_multiple( [10,11,12], this.activeYear ) },

    

    clientsEconomyList(){
      var client_earnings = {}
      var total_amount = 0
      var output = []

      //if( !this.client_earnings_date_from ) this.client_earnings_date_from = moment().year(this.activeYear).month(this.activeMonth)
      //if( !this.client_earnings_date_from ) this.client_earnings_date_from = moment().year(this.activeYear).month(this.activeMonth)

      if( this.client_earnings_date_from && this.client_earnings_date_to ) {
        var datestamp_from = moment( this.client_earnings_date_from ).unix()
        var datestamp_to = moment( this.client_earnings_date_to ).unix()
      }

      var economyposts = this.$store.state.firebase.economyposts

      if(!economyposts) return output      

      for( var key in economyposts ) {
        if(key == '.key') continue // why, vuexfire?

        var economypost = economyposts[key]
        if( !economypost.date_invoiced ) continue
        if( economypost.archived ) continue
        var project = this.$store.state.firebase.projects[ economypost.project_key ]
        if( !project ) continue

        if( datestamp_from && datestamp_to ) {
          economypost.date_timestamp = moment(economypost.date_invoiced).unix()
          if( economypost.date_timestamp < datestamp_from ) continue
          if( economypost.date_timestamp > datestamp_to ) continue
        }

        var client = this.$store.state.firebase.clients[ project.client_key ]
        if(!client_earnings[project.client_key]) client_earnings[project.client_key] = 0
        client_earnings[project.client_key] += parseFloat(economypost.amount_dkk_ex_vat)
        total_amount += parseFloat(economypost.amount_dkk_ex_vat)
      }

      for( var x in client_earnings ) {
        output.push({
          client_key: x,
          earning: client_earnings[x],
          pct: ( ( client_earnings[x] / total_amount ) * 100 ).toFixed(2),
        })
      }

      output.sort(function(a,b){
        return a.earning < b.earning
      })

      return output

    },

    clientsEconomyListPieData() {
      var output = []
      for( var i = 0; i < this.clientsEconomyList.length; i++ ) {
        var entry = this.clientsEconomyList[i]
        output.push(entry.earning)
      }
      return output.toString()
    },

    chart1(){
      var chart = {
        columns: [{
            'type': 'string',
            'label': 'Year'
        }, {
            'type': 'number',
            'label': 'Sales'
        }, {
            'type': 'number',
            'label': 'Expenses'
        }],
        rows: [
            ['2004', 1000, 400],
            ['2005', 1170, 460],
            ['2006', 660, 1120],
            ['2007', 1030, 540]
        ],
        options: {
            title: 'Company Performance',
            hAxis: {
                title: 'Year',
                minValue: '2004',
                maxValue: '2007'
            },
            vAxis: {
                title: '',
                minValue: 300,
                maxValue: 1200
            },
            width: 900,
            height: 500,
            curveType: 'function'
        },
      }
      return chart
    },

    needing_invoices(){
      return this.getFilteredAndTotals({
        invoiced: false,
        hypothetic: false,
      })
    },

    needing_payment(){
      return this.getFilteredAndTotals({
        paid: false,
        hypothetic: false,
      })
    },


  }, // computed
  methods: {

    outputMoney: helpers.outputMoney,
    stringPad: helpers.stringPad,
    getProject: helpers.getProject,    
    
    monthName(no){
      var vals = [ '', 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december' ]
      if(!vals[no]) return no
      return vals[no]
    },

    flipBoolean(key) {
      this[key] = !this[key]
    },


    //getMonthPosts(){ return this.$store.getters['economyposts/getFilteredAndTotals']({ date_from_timestamp:0000, date_to_timestamp:0000, place_posts_by:this.place_posts_by }) },
    
    activeMonth( state,getters,rootState,rootGetters ){
        return getters.getFilteredAndTotals({ place_posts_by:this.place_posts_by })
    },

    activeAccountingYear( state,getters,rootState,rootGetters ){
        return getters.getFilteredAndTotals({  })
    },

    //q1(){ return this.getFilteredAndTotals({ date_from_timestamp:0000, date_to_timestamp:0000, place_posts_by:this.place_posts_by }) },
    //q2(){ return this.getFilteredAndTotals({ date_from_timestamp:0000, date_to_timestamp:0000, place_posts_by:this.place_posts_by }) },
    //q3(){ return this.getFilteredAndTotals({ date_from_timestamp:0000, date_to_timestamp:0000, place_posts_by:this.place_posts_by }) },
    //q4(){ return this.getFilteredAndTotals({ date_from_timestamp:0000, date_to_timestamp:0000, place_posts_by:this.place_posts_by }) },

    // this.getFilteredEconomyposts({ date_from_timestamp:0000, date_to_timestamp:0000, place_posts_by:this.place_posts_by })
    


    getFilteredAndTotals(filters){ return this.$store.getters['economyposts/getFilteredAndTotals'](filters) },


    gotoNextYear(){
      this.month_offset += 12
    },
    gotoPrevYear(){
      this.month_offset -= 12
    },

    gotoNextMonth(){
      this.month_offset += 1
    },
    gotoPrevMonth(){
      this.month_offset -= 1
    },

    gotoMonthByOffset(offset){
      this.month_offset -= offset
    },

    gotoMonthYear(month,year){
      var targetDate = moment().month(month-1).year(year)
      var diff = targetDate.diff( this.now, 'days' )
      diff = Math.round( diff/30 )    
      this.month_offset += diff
    },

    openEconomypost(economypost){
      globals.modal_economypost_edit.economypost = economypost
      globals.modal_economypost_edit.active = true      
    },

  
    createNewEconomypost() {
      var new_economypost = {
        //project_key: '-KGP0YMC6BAAuzH6MdTz',
        created: moment(this.now).format('YYYY-MM-DD hh:mm:SS'),
        //date_due: moment().month(this.activeMonth-1).year(this.activeYear).add(0,'months').format('YYYY-MM-DD'),
        amount_dkk_ex_vat: 0,
        invoice_date: moment(this.now).format('YYYY-MM-DD'),
        payment_due_date: moment(this.now).format('YYYY-MM-DD'),
      }
      fdb.ref('economyposts').push(new_economypost)
      eventBus.$emit('toast', {text:'Økonomipost oprettet'})
    },


    economypostTitle(economypost){
      var t = 'Ny økonomipost'
      if( economypost.title && economypost.title.length ) t = economypost.title
      if( economypost.project_key ) t = this.$store.state.firebase.projects[economypost.project_key].name
      if( economypost.hypothetic ) t = 'Hypotetisk: ' + t
      return t
    },


    isPostInMonth( post, month){
      var a = moment(post.invoice_date,'YYYY-MM-DD')
      var b = moment().year(month.year).month(month.month-1)
      console.log(a.format('YYYY-MM-DD'))
      console.log(b.format('YYYY-MM-DD'))
      return a.isSame(b,'month')
    },


    clickMonthLabel(monthno,activeMonthNo) {
      console.log(monthno)
      console.log(activeMonthNo)
      var offsetAddition = monthno - activeMonthNo

      //if(monthno < this.accounting_month_offset) {        

      console.log( offsetAddition )
      //this.gotoMonth(monthno)
      
      return
      if(monthno < this.accounting_month_offset) {        
        //this.activeYear += 1
      }
      this.activeMonth = monthno
    },

    negaPosi_cls(input){
      var cls = ''
      if( input > 0 ) cls += ' posi '
      if( input < 0 ) cls += ' nega '      
      return cls
    },

    toggle_calculate_hypothetic_posts(){
      this.$store.commit('economyposts/toggle_calculate_hypothetic_posts')
    },

  },//methods
  created(){
    
    if( !this.is_admin ) this.goto('/')

  },//created
}
</script>



// WEBPACK FOOTER //
// Economy.vue?35cd9044